import { render, staticRenderFns } from "./PartnerOrderDetail.vue?vue&type=template&id=5e1bf2a5&scoped=true&"
import script from "./PartnerOrderDetail.vue?vue&type=script&lang=tsx&"
export * from "./PartnerOrderDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./PartnerOrderDetail.vue?vue&type=style&index=0&id=5e1bf2a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1bf2a5",
  null
  
)

export default component.exports